export default __webpack_public_path__ + "static/media/qr_code2.8c196ef4.png";